import { Card, CardContent } from "../../components/ui/card.js";
import { Badge } from "../../components/ui/badge";
// import { useToast } from "../../hooks/useToast";
import { useState } from "react";
import LaunchHero from "./LaunchHero";
import BenefitsSection from "./BenefitsSection.js";
import WeeklyCompetition from "./WeeklyCompetition.js";
// import CompanyProfileForm from "@/components/CompanyProfileForm";
// import WeeklyCompetition from "@/components/WeeklyCompetition";
// import BenefitsSection from "@/components/BenefitsSection";
// import AnalyticsDashboard from "@/components/AnalyticsDashboard";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const LaunchLanding = () => {
  // const { toast } = useToast();
  const [activeTab, setActiveTab] = useState("profile");
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      
      <main>
        {/* Hero Section */}
        <LaunchHero />

        {/* Launch Your Product Section */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">
                  Launch Your Product on LeadrPro
                </h2>
                <p className="text-lg text-gray-600 mb-6">
                  Join our community of innovators and showcase your product to 50,000+ decision makers.
                  Get discovered, receive feedback, and connect with potential customers.
                </p>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <svg
                        className="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p className="ml-3 text-gray-700">Reach 50,000+ decision makers</p>
                  </div>
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <svg
                        className="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p className="ml-3 text-gray-700">Get featured in our weekly newsletter (10,000+ subscribers)</p>
                  </div>
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <svg
                        className="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p className="ml-3 text-gray-700">
                      Win badges to increase your visibility on the platform
                    </p>
                  </div>
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <svg
                        className="h-6 w-6 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <p className="ml-3 text-gray-700">
                      Access detailed analytics about your product's performance
                    </p>
                  </div>
                </div>
                <div className="mt-8">
                  <button 
                    className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 text-lg"
                    onClick={() => navigate("/launch/submit-product")}
                  >
                    Get Started <ArrowRight className="ml-2" />
                  </button>
                </div>
              </div>
              <div className="relative">
                <div className="absolute -top-6 -right-6 bg-purple-100 rounded-full w-32 h-32 z-0"></div>
                <div className="relative rounded-lg border border-gray-200 shadow-lg overflow-hidden z-10">

                  <div className="p-6">
                    <div className="flex justify-between items-center mb-4">
                      <div className="flex items-center">
                        <div className="bg-blue-500 h-10 w-10 rounded-full flex items-center justify-center text-white font-bold">
                          S
                        </div>
                        <div className="ml-3">
                          <h3 className="font-bold text-gray-900">Skuad</h3>
                          <p className="text-sm text-gray-500">Human Resources</p>
                        </div>
                      </div>
                    </div>
                    <p className="text-gray-700 mb-4">
                      Global HR Simplified: Hire globally without the hassles of setting up entities
                    </p>
                    <div className="flex items-center text-sm text-gray-500">
                      <span className="font-medium text-gray-900">12.4K</span>
                      <span className="mx-1">impressions</span>
                      <span className="mx-2">•</span>
                      <span className="font-medium text-gray-900">Top 3</span>
                      <span className="mx-1">last week</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <BenefitsSection /> */}
          </div>
        </section>

        {/* Weekly Competition Section */}
        {/* <section className="bg-gradient-to-b from-purple-50 to-white py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <WeeklyCompetition />
          </div>
        </section> */}

       
      </main>
    </div>
  );
};

export default LaunchLanding;